import { VList } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VList,{attrs:{"three-line":""}},[[_vm._l((_vm.companyLocations),function(companyLocation){return _c('InventoriesCompanyLocationsListTile',{key:companyLocation.id,attrs:{"company-location":companyLocation},on:{"openCompanyLocationDialog":_vm.openCompanyLocationDialog}})}),(_vm.companyLocations?.length == 0)?_c('div',{staticClass:"company-locations-tile-empty"},[_vm._v(" "+_vm._s(_vm.t("noDataText"))+" ")]):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }